import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { ApiService } from "./api.service";
import { ProfileModel } from "../models/profile.model";

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private readonly apiService: ApiService) { }

  getAzureProfileData(userId: string): Observable<ProfileModel>{
    const data = {
      userId : userId
    };
    return this.apiService.post<ProfileModel>(environment.graph.endpoint, data);
  }
}
